import Button from "../../../../form/Button";
import React from "react";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems, actionButtons} = props;
    return <Button key="1" disabled={ props.isLoading } color="default" className={propsTop.otherSide || "pull-left"}
                   onClick={props.pristineForm}>
        Új
    </Button>
}